import { render } from "./PackagePlan.vue?vue&type=template&id=3c39ada8&scoped=true"
import script from "./PackagePlan.vue?vue&type=script&lang=js"
export * from "./PackagePlan.vue?vue&type=script&lang=js"

import "./PackagePlan.vue?vue&type=style&index=0&id=3c39ada8&scoped=true&lang=scss"

import exportComponent from "C:\\Bohdan\\telesim_test\\telesim-admin-panel\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c39ada8"]])

export default __exports__